/* eslint-disable no-unused-vars */
import React, { FC, memo, useEffect, useState } from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import { warrantyTextStyles } from 'src/views/transactions/TransactionPDF/styles';
import { drjInfo } from 'src/constants';
import { NewBranchData, TemplateDetails } from 'src/types';
import { dateToday } from 'src/utils';
import QRCode from 'qrcode';

const styles = StyleSheet.create({
  viewParent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexDirection: 'row'
  },
  infoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10
  },
  logo: { height: 45, width: 52 },
  templateQrImg: { height: 46, width: 46 },
  headerText: {
    fontSize: 5.5
  }
});

interface Props {
  branchInfo?: NewBranchData;
  quotationData?: TemplateDetails;
}

const component: FC<Props> = ({ branchInfo, quotationData }) => {
  // eslint-disable-next-line no-unused-vars
  const [uriQR, setUriQR] = useState<string>('');

  const getTemplateIdUrl = () => {
    if (!quotationData?.id) return;

    const quotationIdUriStr: string = `${quotationData?.id}`;
    QRCode.toDataURL(quotationIdUriStr, {
      errorCorrectionLevel: 'L',
      margin: 1
    })
      .then((url) => setUriQR(url))
      .catch((err) => console.error(err));
  };

  useEffect(getTemplateIdUrl, [quotationData?.id]);

  return (
    <View style={styles.viewParent}>
      <View>
        <Image
          style={styles.logo}
          src="/static/images/avatars/pcworth_logo.png"
        />
        <View style={{ position: 'absolute', top: 47.5, width: 100 }}>
          <Text
            style={[
              warrantyTextStyles.openSansRegular,
              { fontSize: 5, color: '#2B3445' }
            ]}
          >
            Sales: {quotationData?.created_by ?? 'N/A'}
          </Text>
          <Text
            style={[
              warrantyTextStyles.openSansRegular,
              { fontSize: 5, color: '#2B3445' }
            ]}
          >
            Date: {`${dateToday()}`}
          </Text>
        </View>
      </View>

      <View style={styles.infoContainer}>
        <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
          Owned and Operated by:
        </Text>
        <Text style={[warrantyTextStyles.openSansBold, styles.headerText]}>
          {drjInfo.name}
        </Text>

        <Text style={{ maxLines: 1 }}>
          <Text
            style={[warrantyTextStyles.openSansSemiBold, styles.headerText]}
          >
            Location:
          </Text>
          <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
            {' '}
            {branchInfo?.address ?? drjInfo.location}
          </Text>
        </Text>

        {/* <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
          <Text style={[warrantyTextStyles.openSansSemiBold, styles.headerText]}>Website:</Text>
          <Text style={[warrantyTextStyles.url, [warrantyTextStyles.openSansRegular, styles.headerText]]}>
            {' '}
            {drjInfo.website}
          </Text>
          <Text> </Text>
          <Text style={[warrantyTextStyles.openSansSemiBold, styles.headerText]}>Facebook:</Text>
          <Text style={[warrantyTextStyles.url, [warrantyTextStyles.openSansRegular, styles.headerText]]}>
            {' '}
            {drjInfo.facebook}
          </Text>
        </Text> */}

        <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
          <Text
            style={[warrantyTextStyles.openSansSemiBold, styles.headerText]}
          >
            Email:
          </Text>
          <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
            {' '}
            {drjInfo.email}
          </Text>
          <Text> </Text>
          <Text
            style={[warrantyTextStyles.openSansSemiBold, styles.headerText]}
          >
            Viber:
          </Text>
          <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
            {' '}
            {drjInfo.cellNo2}
          </Text>
        </Text>

        <Text style={[warrantyTextStyles.openSansRegular, styles.headerText]}>
          <Text
            style={[warrantyTextStyles.openSansSemiBold, styles.headerText]}
          >
            Contact Details:
          </Text>{' '}
          {drjInfo.telNo} / {drjInfo.cellNo}
        </Text>
      </View>

      <View style={{ alignItems: 'center' }}>
        {uriQR ? <Image style={styles.templateQrImg} src={uriQR} /> : null}

        <Text
          style={[
            warrantyTextStyles.openSansRegular,
            { fontSize: 5.5, textAlign: 'center' }
          ]}
        >
          {quotationData?.id}
        </Text>
      </View>
    </View>
  );
};

export const ViewQuotationHeaderSlip = memo(component);
